<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay
        z-index="50"
    ></v-overlay>

    <v-navigation-drawer
        absolute class="view"
        permanent
        right
        width="800"
    >
      <!--<v-card>-->
      <v-btn v-if="route.code && this.routes.length > 1" :disabled="this.routes.length < 2" color="primary" fab fixed
             left outlined
             small
             top
             @click="onClickPrevious()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn v-if="route.code && this.routes.length>1" :disabled="this.routes.length < 2" color="primary" fab fixed
             outlined right
             small
             top
             @click="onClickNext()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-content v-if="activeTab==='Info'">
        <v-card-title v-if="route.code" class="headline">
          {{ route.code }}
          <v-btn :color="RouteConst.color(route.status)" class="headline_status" small tile>
            {{ RouteConst.map(route.status) }}
          </v-btn>
        </v-card-title>

        <!--<v-card-text>Info</v-card-text>-->

        <div class="contents">
          <v-card>
            <v-container class="container--fluid pt-0">
              <v-row>
                <v-col>

                  ทะเบียน {{ route.results && route.results.truck && route.results.truck.plate }}:
                  <TypeBadge v-if="route.customer" :small="true" :type="route.customer.type"></TypeBadge>
                  {{ route.customer && route.customer_code }}

                  <v-btn v-if="!route.code" :color="RouteConst.color(route.status)" class="headline_status" small tile>
                    {{ RouteConst.map(route.status) }}
                  </v-btn>

                  <br/>
                  คนขับ: {{ route.results && route.results.truck && route.results.truck.driver_name }}<br/>

                  เบี้ยเลี้ยง {{ $helper.number_format(route.driver_cost) }} บาท
                  (โอที {{ $helper.number_format(route.ot_cost) }} บาท)<br/>
                  ที่พัก {{ $helper.number_format(route.accommodation_cost) }} บาท
                  {{
                    route.results && route.results.optimized && route.results.optimized.filter(data => data.action == 'REST').length > 0 ? '(' + route.results.optimized.filter(data => data.action == 'REST').length + ' คืน)' : ''
                  }}<br/>
                  น้ำมัน {{ $helper.number_format(route.fuel_cost) }} บาท
                  ทางด่วน {{ $helper.number_format(route.motorway_cost) }} บาท<br/>

                  <span v-if="!is_LoadSubmitRoute && route.status>=RouteConst.STATUS_APPROVED_PENDING_SYNC">
                    DOCBOOK: {{ route.shipping?route.shipping.code:route.docbook }}
                  </span>

                </v-col>
                <v-col class="col-6">
                  หมายเหตุ:
                  {{ route.comment }}

                  <hr/>
                  ขนขึ้น {{ $helper.date_format_short_with_time(route.load_at) }} <br/>
                  เริ่มส่ง {{ $helper.date_format_short_with_time(route.start_at) }} - {{
                    $helper.date_format_short_with_time(route.end_at)
                  }}
                  <br/>
                  ระยะทาง {{ $helper.number_format(route.total_distance, 0) }} km
                  <br/>
                  ลูกค้า
                  {{
                    route.results && route.results.optimized && route.results.optimized.filter(data => data.action == 'UNLOAD' && data.code != 'base').length > 0 ? route.results.optimized.filter(data => data.action == 'UNLOAD' && data.code != 'base').length : ''
                  }}
                  ราย<br/>

                  ปริมาตร {{ $helper.number_format(route.total_volume_cbm) }}cbm น้ำหนัก {{
                    $helper.number_format(route.total_weight_kg, 0)
                  }}kg <br/>

                  มูลค่า {{ $helper.number_format(route.total_worth, 0) }} บาท
                  ค่าใช้จ่าย {{ $helper.number_format(route.total_cost, 0) }} บาท
                  ({{ $helper.number_format(route.total_cost / route.total_worth * 100) }}%)

                  <div v-if="route.still_pending" class="small red pa-1 mt-1"
                       style="color: white;font-size: 14px;text-align: center;">
                    ต้องรอทุกออเดอร์อนุมัติก่อนถึงจะอนุมัติใบ DO ได้
                  </div>
                </v-col>
              </v-row>
              <v-row
                  v-if="!this.tabs_info.isLoad &&  !is_LoadSubmitRoute
                  && [RouteConst.STATUS_DRAFT,RouteConst.STATUS_RESERVE].includes(route.status)">

                <v-col v-if="isApproveAble"
                       class="offset-2 col-2 text-right">
                  <v-btn :loading="is_LoadSubmitRoute" class="error" tile @click="RejectRoute()">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>

                <v-col v-if="isApproveAble && [RouteConst.STATUS_DRAFT].includes(route.status)"
                       class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitRoute" class="secondary" tile @click="ReserveRoute()">
                    จองทริป
                  </v-btn>
                </v-col>
                <v-col v-if="isApproveAble && [RouteConst.STATUS_RESERVE].includes(route.status)"
                       class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitRoute" class="secondary" tile @click="CancelReserveRoute()">
                    ยกเลิกจอง
                  </v-btn>
                </v-col>

                <v-col v-if="isApproveAble" class="offset-1 col-3 text-right">
                  <v-select
                      v-model="route.docbook"
                      :items="[
                      {'value':'DOAMT','text':'DOAMT'},
                      {'value':'DOAPJ','text':'DOAPJ'},
                      {'value':'DOATR','text':'DOATR'},
                      {'value':'DOASL','text':'DOASL'},
                      {'value':'DOAOS','text':'DOAOS'},
                      {'value':'DOACM','text':'DOACM'},

                    ]"
                      hide-details
                      label="DOCBOOK"
                      outlined
                      required
                  ></v-select>

                </v-col>
                <v-col v-if="isApproveAble" class="col-2 text-left">
                  <v-btn
                      :disabled="route.still_pending"
                      :loading="is_LoadSubmitRoute" class="primary" tile @click="ApproveRoute()">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <!--{{route}}-->


          <v-simple-table v-if="route.results" class="itemTable">
            <template v-slot:default>
              <!--              <thead>-->
              <!--              <tr class="ItemHead">-->
              <!--                <th class="text-left">รายการ</th>-->
              <!--                <th class="text-right">ชิ้น</th>-->
              <!--                <th class="text-right">น้ำหนัก</th>-->
              <!--                <th class="text-right">ปริมาตร</th>-->
              <!--                <th class="text-right">มูลค่า</th>-->
              <!--              </tr>-->
              <!--              </thead>-->
              <tbody v-for="(action, index) in route.results.optimized"
                     :key="index"
                     :currentIndex="index"
                     class="ItemRow"
              >
              <tr v-if="action.action==='LOAD'">
                <td colspan="5">ขนสินค้าขึ้นรถ {{ $helper.date_format_short_with_time(route.load_at) }}</td>
              </tr>
              <tr v-else-if="action.action==='UNLOAD' && action.code!='base' && !action.non_average">
                <td style="vertical-align: top;width: 150px">{{ $helper.date_format_time(action.datetime_from) }} -
                  {{ $helper.date_format_time(action.datetime_to) }}
                </td>
                <td colspan="4" style="vertical-align: top">ส่ง

                  {{ action.code }}
                  <span v-if="route.orders[action.code].status == 99 && action.code.includes('PENDING:')"
                        class="ml-1 red pa-1 float-right"
                        style="color: white;word-break: keep-all">ยกเลิก</span>
                  <span v-if="route.orders[action.code].status != 99 && action.code.includes('PENDING:')"
                        class="ml-1 red pa-1 float-right"
                        style="color: white;word-break: keep-all">รออนุมัติ</span>
                  (กำหนด
                  {{
                    route.orders[action.code] && route.orders[action.code].date_delivery ? $helper.date_format_short(route.orders[action.code]['date_delivery']) : '??'
                  }})<br/>
                  {{ route.orders[action.code] ? route.orders[action.code]['customer']['name'] : '' }}
                  <div v-for="(item, index) in route.orders[action.code].items"
                       :key="index"
                       :currentIndex="index">
                    {{ item.index_no }}. {{ item.product.code }} {{ item.product.nickname }}

                    <span class="float-right mr-8">

                    <span v-if="item.quantity / item.product.unit_prim_rate>=1">
                        {{
                        Math.floor(item.quantity / item.product.unit_prim_rate)
                      }} {{ $helper.parseUnit(item.product.unit_single) }}
                    </span>

                    <span
                        v-if="item.quantity - Math.floor(item.quantity / item.product.unit_prim_rate) * item.product.unit_prim_rate>0">
                        {{
                        item.quantity - Math.floor(item.quantity / item.product.unit_prim_rate) * item.product.unit_prim_rate
                      }} {{ $helper.parseUnit(item.product.unit_primitive) }}


                    </span>

</span>
                  </div>
                  <div>

                    ------------------------------------------
                  </div>
                  <div>
                    รวม น้ำหนัก {{ $helper.number_format(action['weight']) }}kg
                    ({{ $helper.number_format(action['volume']) }}cbm)<br/>
                    มูลค่า {{ $helper.number_format(action['worth']) }} บาท
                  </div>
                  <div>

                    ------------------------------------------
                  </div>
                </td>
                <!--                <td style="text-align: right">นน. {{ $helper.number_format(action.weight, 1, 1) }}kg</td>-->
                <!--                <td style="text-align: right">cbm. {{ $helper.number_format(action.volume, 2, 2) }}</td>-->
                <!--                <td style="text-align: right">มูลค่า {{ $helper.number_format(action.worth, 2, 2) }}บาท</td>-->
              </tr>
              <tr v-else-if="action.action==='UNLOAD' && action.code!='base' && action.non_average">
                <td style="vertical-align: top;width: 150px">{{ $helper.date_format_time(action.datetime_from) }} -
                  {{ $helper.date_format_time(action.datetime_to) }}
                </td>
                <td colspan="4" style="vertical-align: top">{{ action.code }} <br/>
                  {{ route.orders[action.code]['customer']['name'] }}
                  <div>

                    ------------------------------------------
                  </div>
                  <div>
                    รวม น้ำหนัก {{ $helper.number_format(action['weight']) }}kg
                    ({{ $helper.number_format(action['volume']) }}cbm)<br/>
                    มูลค่า {{ $helper.number_format(action['worth']) }} บาท
                  </div>
                  <div>

                    ------------------------------------------
                  </div>
                </td>
                <!--                <td style="text-align: right">นน. {{ $helper.number_format(action.weight, 1, 1) }}kg</td>-->
                <!--                <td style="text-align: right">cbm. {{ $helper.number_format(action.volume, 2, 2) }}</td>-->
                <!--                <td style="text-align: right">มูลค่า {{ $helper.number_format(action.worth, 2, 2) }}บาท</td>-->
              </tr>
              <tr v-else-if="action.action==='UNLOAD' && action.code=='base'">

                <td colspan="5" style="vertical-align: top">กลับที่พักเชียงใหม่<br/>
                </td>
                <!--                <td style="text-align: right">นน. {{ $helper.number_format(action.weight, 1, 1) }}kg</td>-->
                <!--                <td style="text-align: right">cbm. {{ $helper.number_format(action.volume, 2, 2) }}</td>-->
                <!--                <td style="text-align: right">มูลค่า {{ $helper.number_format(action.worth, 2, 2) }}บาท</td>-->
              </tr>
              <tr v-else-if="action.action==='DRIVE'">
                <td style="vertical-align: top">{{ $helper.date_format_time(action.datetime_from) }} -
                  {{ $helper.date_format_time(action.datetime_to) }}
                </td>
                <td style="vertical-align: top">ขับรถจาก
                  {{
                    route.districts[action.code.split('-')[0]]['name']
                  }}/{{
                    route.districts[action.code.split('-')[0]]['city']['name']
                  }}/{{ route.districts[action.code.split('-')[0]]['province']['name'] }}
                  <br/>
                  ไป
                  {{
                    route.districts[action.code.split('-')[1]]['name']
                  }}/{{
                    route.districts[action.code.split('-')[1]]['city']['name']
                  }}/{{ route.districts[action.code.split('-')[1]]['province']['name'] }}

                </td>
                <td colspan="3" style="text-align: right;vertical-align: top">ระยะทาง. {{
                    $helper.number_format(action.distance, 1, 1)
                  }}km
                </td>
              </tr>
              <tr v-else-if="action.action==='LUNCH'">
                <td colspan="1" style="vertical-align: top">พักกลางวัน
                </td>
                <td colspan="4" style="vertical-align: top"></td>
              </tr>
              <tr v-else-if="action.action==='REST'">
                <td colspan="1" style="vertical-align: top">พักค้างคืน
                </td>
                <td colspan="4" style="vertical-align: top"> {{ route.provinces[action.code]['name'] }}</td>
              </tr>
              <tr v-else>
                <td>{{ action.action }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>


          <v-footer class="pb-10">
            <v-container>

              <v-row v-for="(post, index) in route.timeline"
                     :key="index"
                     :route="route">
                <v-col>
                  <span style="zoom: 0.6"><Avatar :active="true"
                                                  :user="$store.state.users.id_map[post.user_id]"></Avatar></span>
                  <span class="caption ml-4">{{ $helper.date_format_short_with_time(post.created_at) }}</span><br/>
                  <span class="ml-4">{{ post.content }}</span>
                </v-col>
              </v-row>
              <v-row v-if="!this.tabs_info.isLoad ">
                <v-col class="">
                  <v-textarea
                      v-model="user_comment"
                      height="40px"
                      label="Comment"
                      outlined
                  ></v-textarea>
                </v-col>
                <v-col class="col-2">
                  <v-btn
                      :loading="user_comment_saving"
                      class="primary" @click="postComment()">
                    Send
                  </v-btn>
                </v-col>
              </v-row>


            </v-container>
          </v-footer>
        </div>
      </v-content>


      <v-content v-if="activeTab==='Timeline'">
        <v-card-title class="headline">{{ route.code }}</v-card-title>
        <v-card-text>Timeline</v-card-text>


      </v-content>

      <v-content v-if="activeTab==='Quotation'">
        <iframe :src="quotationUrl" class="quotation_iframe"></iframe>
      </v-content>


      <v-app-bar bottom fixed height="60">
        <!--<v-footer bottom>-->
        <!--<template v-slot:default>-->
        <v-tabs
            v-model="active_tab"
            bottom
            center-active

            fixed
            height="60"
            slider-color="slider"
            slider-size="5"
            style="padding-left: 100px"
        >


          <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>

        </v-tabs>
        <!--</template>-->
      </v-app-bar>


      <v-btn
          v-if="[RouteConst.STATUS_DRAFT,RouteConst.STATUS_RESERVE].includes(route.status)"
          :loading="tabs_info.isLoad" bottom class="close-button primary" fixed float right
          style="margin-right: 410px;bottom: 18px"
          tiled
          x-large
          @click="EditRoute()"
      >
        แก้ไขทริป
      </v-btn>


      <a :href="'/api/route/'+route.id+'/document?t/&token='+$helper.access_token()"
         target="_blank">
        <v-btn
            :loading="is_LoadSubmitRoute" bottom class="close-button primary" fixed float right
            style="margin-right: 250px;bottom: 18px"
            tiled
            x-large
        >
          ใบอนุมัติ
        </v-btn>
      </a>
      <a :href="'/api/route/'+route.id+'/route_google_route?t/&token='+$helper.access_token()"
         target="_blank">
        <v-btn
            :loading="is_LoadSubmitRoute" bottom class="close-button primary" fixed float right
            style="margin-right: 100px;bottom: 18px"
            tiled
            x-large
        >
          เส้นทาง
        </v-btn>
      </a>


      <v-btn :loading="is_LoadSubmitRoute" bottom class="close-button" color="primary" fab fixed float
             right
             @click="()=>{this.close()}">
        <v-icon>mdi-close</v-icon>
      </v-btn>


      <v-btn
          v-if="
                route.status===RouteConst.STATUS_DRAFT ||
                route.status===RouteConst.STATUS_REJECT
              "
          :loading="is_LoadSubmitRoute" bottom class="delete-button" color="error" fab fixed float
          left
          style="z-index: 5"
          @click="deletingObject(route)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>


      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
.contents {
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_iframe {
  width: 100%;
  broute: 0;
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_share {
  margin-bottom: 90px;
}

.headline {
  padding-top: 20px;
  padding-bottom: 0;
  height: 56px;
}

.headline_status {
  margin-left: 10px;
}

.overlay {
  z-index: 50 !important;
}

.view {
  z-index: 60 !important;

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }
}

.item-qty {
  min-width: 80px;
}

.list-container {
  .list-row {
    position: relative;
    height: auto;
    margin-left: 0;
  }

  .list-row {
    font-size: 20px;
  }

  @media all and (max-width: 599px) {
    .list-row {
      font-size: 16px;
    }
  }
  @media all and (min-width: 600px) and (max-width: 720px) {
    .list-row {
      font-size: 18px;
    }
  }
  @media all and (min-width: 720px) and (max-width: 960px) {
    .list-row {
      font-size: 20px;
    }
  }
}

.itemTable {

  line-height: 1.2;
}

.ItemHead {
  th {
    font-size: 16px;
  }
}

.ItemRow {
  td {
    font-size: 16px;
    padding: 0 4px;
  }

  td:first-child {
    font-size: 16px;
    padding-left: 8px;
  }

  td:last-child {
    padding-right: 8px;
  }

}

</style>
<script lang="ts">


import {SimpleResponse} from '@/models/Model'
import {DataRoute, Route, RouteConst} from '@/models/Route'
import {Timeline, TimelineConst} from '@/models/Timeline'
import {User, UserConst} from '@/models/User'
import md5 from 'md5'
import {Component, Vue} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import ItemRow from '../components/Route/ItemRow.vue'
import StatusBadge from '../components/Route/StatusBadge.vue'
import TabForDialog from '../components/TabForDialog.vue'
import Avatar from '../components/User/Avatar.vue'
import router from '../router'
import Helper from '../services/Helper.js'

@Component({
  components: {Avatar, TypeBadge, TabForDialog, ItemRow, CreditBar, StatusBadge},
})
export default class RouteDialog extends Vue {

  open = false

  isOpenSaleCondition = false
  isSaveSaleCondition = false

  md5 = md5

  index = 0
  routes: Route[] = []
  activeTab: string = 'Info'
  RouteConst = RouteConst

  active_tab = 0

  tabs_info = {
    key: 'info',
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
  }
  tabs_quotation = {
    key: 'quotation',
    name: 'ใบเสนอราคา',
    click: () => this.click_tab('Quotation'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
    isAdded: false,
  }
  tabs_timeline = {
    name: 'Timeline',
    click: () => this.click_tab('Timeline'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5,
  }
  tabs = [
    this.tabs_info,
  ]
  dialog: boolean = false
  user_comment: string = ''
  user_comment_saving: boolean = false
  route: Route = new Route()
  isLoadRoute = false
  is_LoadSubmitRoute = false
  is_ApprovingComOption = false
  sales: User[] = []
  isPriceLessThanLimit = false
  is_open_quotation: boolean = false
  quotationUrl = ''

  get isInRouteSales() {
    const user_code = this.$store.state.$user.employee_code
    return this.sales.filter(user => user.employee_code == user_code).length > 0
  }


  get isApproveComOptionAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      default:
        return false
    }


  }

  get isApproveAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      case UserConst.ROLE_MANAGER:
        return true
      case UserConst.ROLE_LOGISTIC:
        return true
      default:
        return false
    }


  }

  onApply: Function = () => {

  }

  openSaleCondition() {

    this.isOpenSaleCondition = true
  }

  onOpen({id, route, routes, index, debug, skip_load, onApply}) {
    if (this.open) return
    console.log('Emited', {route, routes, index, debug})

    this.tabs_quotation.isAdded = false
    this.tabs = this.tabs.filter(tab => tab.key != 'quotation')
    this.activeTab = 'Info'
    this.active_tab = 0


    this.route = new Route()
    if (route) {
      this.route = route
    } else if (id) {
      this.route.id = id
    }
    if (index && routes) {
      this.index = index
      this.routes = routes
    } else {
      this.index = 0
      this.routes = []
    }

    this.open = true
    this.sales = []
    if (skip_load) {
    } else {
      this.getRoute()
    }
    this.onApply = onApply

    // console.log(this.route.results)


  }

  mounted() {
    this.$root.$on('openRoute', this.onOpen)
  }

  onClickPrevious() {
    if (this.routes.length > 1) {
      this.index = (this.index - 1) % this.routes.length
      this.route = this.routes[this.index]
      this.getRoute()
    }
  }

  onClickNext() {
    if (this.routes.length > 1) {
      this.index = (this.index + 1) % this.routes.length
      this.route = this.routes[this.index]
      this.getRoute()
    }
  }

  click_tab(name: string): void {
    if (name === 'Cart') {
      this.close()
      router.push('/cart')
    } else {
      this.activeTab = name
    }

  }

  async postComment() {
    this.user_comment_saving = true
    let timeline = new Timeline()
    timeline.created_at = new Date()
    timeline.recordable_type = 'App\\Models\\logistic\\Route'
    timeline.recordable_id = this.route.id
    timeline.user_id = this.$store.state.$user.id
    timeline.type = TimelineConst.TYPE_COMMENT
    timeline.content = this.user_comment
    try {
      await timeline.save()
      this.route.timeline.push(timeline)

      this.user_comment = ''
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.user_comment_saving = false

  }

  getRoute() {
    const id = this.route.id
    this.tabs_info.isLoad = true
    Helper.get(Helper.setting.route.getResourceAPI.replace('{id}', id))
        .then<{ data: DataRoute }>(({data}) => {

          console.log('getRoute', data.data)
          this.route = data.data

          if(this.route.results?.optimized.length==0){
            this.EditRoute()
          }
          // this.items = data.data

          //this.$store.commit('routes_response', data)
          //this.reloadItem()
          this.tabs_info.isLoad = false
        }).catch(error => {
      if (error && error.response && error.response.status == 404) {
        this.$root.$emit('onError', {message: 'ไม่พบออร์เดอร์', error: error})
        this.close()
      } else {
        this.$root.$emit('onError', {error: error})
      }
    })

  }

  async ApproveRoute() {
    if (!this.route.docbook) {
      this.$root.$emit('onWarning', {message: 'กรุณาเลือก DOCBOOK'})
      return
    }
    this.is_LoadSubmitRoute = true
    try {
      await this.SetRouteStatus(RouteConst.STATUS_APPROVED_PENDING_SYNC, this.route.docbook)
      this.$root.$emit('onSuccess', {message: 'อนุมัติจัดทริปเรียบร้อย'})
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.is_LoadSubmitRoute = false
  }

  async RejectRoute() {
    await this.SetRouteStatus(RouteConst.STATUS_REJECT)
    this.close()
    this.$root.$emit('refreshRoute')
  }

  async ReserveRoute() {
    await this.SetRouteStatus(RouteConst.STATUS_RESERVE)
    this.close()
    this.$root.$emit('refreshRoute')
  }


  async CancelRoute() {
    await this.SetRouteStatus(RouteConst.STATUS_DRAFT)
    this.close()
    this.$root.$emit('refreshRoute')
  }

  async CancelReserveRoute() {
    await this.SetRouteStatus(RouteConst.STATUS_DRAFT)
    this.close()
    this.$root.$emit('refreshRoute')
  }


  //
  // async ConfirmRoute() {
  //   if (this.isPriceLessThanLimit) {
  //     this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
  //     return
  //   }
  //
  //   let route: Route = this.route
  //
  //   if (!route.hasOwnProperty('ConfirmRoute')) {
  //     route = Object.setPrototypeOf(route, Route.prototype)
  //   }
  //   this.is_LoadSubmitRoute = true
  //   // debugger
  //   try {
  //     route = await route.ConfirmRoute()
  //     //this.$store.commit('carts_remove', route)
  //     console.log(this.onApply)
  //     this.onApply && this.onApply()
  //     this.close()
  //
  //     this.$root.$emit('onSuccess', {message: 'ส่งใบจัดทริปเรียบร้อย'})
  //   } catch (e) {
  //     // alert(e);
  //   }
  //   this.is_LoadSubmitRoute = false
  // }

  close() {
    this.open = false
  }

  async SetRouteStatus(status: number, docbook: string | null = '') {
    if (this.route.status == status) return
    let route: Route = new Route()
    route.id = this.route.id
    route.mode = 'status'
    route.docbook = docbook
    if (!route.hasOwnProperty('SetStatus')) {
      route = Object.setPrototypeOf(route, Route.prototype)
    }
    this.is_LoadSubmitRoute = true
    // debugger
    try {
      route = await route.SetStatus(status)
      this.route = route
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitRoute = false
    return route
  }

  async deletingObject(route: Route) {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject(route)
        this.close()
      } else {

      }
    })

  }

  async deleteObject(route: Route) {
    // this.is_LoadSubmitRoute = true
    try {
      if (!route.hasOwnProperty('delete')) {
        route = Object.setPrototypeOf(route, Route.prototype)
      }
      const response: SimpleResponse = await route.delete()

      this.routes = this.routes.filter(object => object.id != this.route?.id)

      this.$root.$emit('onSuccess', {message: response.toString()})
    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }

  }

  share(route: Route) {

  }

  created() {
    this.tabs = []
  }


  async EditRoute() {
    console.log('emit openRouteEditor',this.route.export_drop)
    // debugger
    this.$root.$emit('openRouteEditor', {
      export_drop: this.route.export_drop,
      ref_route: this.route,
      onApply() {
        this.$root.$emit('refreshRoute')
      },
    })
    this.close()
  }
};

</script>
